import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "./theme";
import { createContext } from "@chakra-ui/react-utils";
import { brands } from "./data";
import { ErrorState } from "./components/ErrorState";

// Pages
import { Home } from "./pages/home";
import { Details } from "./pages/details";

const brandsArr = Object.keys(brands);

const router = createBrowserRouter([
  ...brandsArr.map(brand => ({
    path: `/:lang/${brand}`,
    element: <Home />,
  })),
  ...brandsArr.map(brand => ({
    path: `/:lang/${brand}/details/:product`,
    element: <Details />,
  })),
  {
    path: "*",
    element: <ErrorState />,
  },
]);

function App() {
  const brand = window.location.pathname.split("/")[2];

  return (
    <ErrorBoundary fallback={<ErrorState />}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrandProvider value={{ brand }}>
          <RouterProvider router={router} />
        </BrandProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export const [LangProvider, useLangContext] = createContext({
  name: "LangProvider",
});

export const [BrandProvider, useBrandContext] = createContext({
  name: "BrandProvider",
});

export default App;
